import React from 'react';

const APP_STORE_LINK = 'itms-apps://itunes.apple.com/us/app/apple-store/6445992216?mt=8';
const PLAY_STORE_LINK = 'https://play.google.com/store/apps/details?id=com.looko.aclosetbusiness';

/**
 * LookAI 앱 이동 시도 후, 실패시 2초 뒤 앱 다운로드 페이지로 이동하는 hook
 */
export const useAppStoreHandler = () => {
  return React.useCallback(() => {
    const userAgent = navigator.userAgent || '';
    let storeLink: string = '';

    // iOS
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      storeLink = APP_STORE_LINK;
    }

    // Android
    if (/android/i.test(userAgent)) {
      storeLink = PLAY_STORE_LINK;
    }

    if (storeLink) {
      const close = setTimeout(() => {
        window.location.href = storeLink;
      }, 2000);

      if (document.hidden) {
        clearTimeout(close);
      }

      window.location.href = 'aclosetbusiness://';
    }
  }, []);
};
